import { createStore } from "vuex";
import axios from "axios";
import { API_BASE_URL } from "@/consts";
// import { formatDate } from "@/helpers";
import moment from "moment";
import AdminNewDashboardStore from "@/components/AdminNewDashboard/AdminNewDashboardStore";

export default createStore({
  state: {
    isLoggedIn: false,
    partnerId: null,
    isLoading: false,
    loadingRequest: 0,
    partner: {},
    seller: {},
    admin: {},
    groupAdmin: {},
    podcaster: {},
    podcastAdmin: {},
    isSellerLoggedIn: false,
    sellerId: null,
    sellerPartnerId: null,
    podcasterId: null,
    isAdminLoggedIn: false,
    isGroupAdminLoggedIn: false,
    isPodcasterLoggedIn: false,
    isPodcastAdminLoggedIn: false,
    // ___ Network Admin ___
    networkAdmin: {},
    isNetworkAdminLoggedIn: false,
    // ___ Auxigen ___
    auxigen: {},
    isAuxigenLoggedIn: false,
    shows: [],
    podcasters: [],
    podcastersWithReferrals: [],
    episodes: [],
    campaigns: [],
    alerts: [],
    sellers: [],
    groups: [],
  },
  mutations: {
    setSellerLoggedIn(state, value) {
      state.isSellerLoggedIn = value;
    },
    setSellerId(state, value) {
      state.sellerId = value;
    },
    setSellerPartnerId(state, value) {
      state.sellerPartnerId = value;
    },
    setLoggedIn(state, value) {
      state.isLoggedIn = value;
    },
    setGroupAdminLoggedIn(state, value) {
      state.isGroupAdminLoggedIn = value;
    },
    setPartnerId(state, value) {
      state.partnerId = value;
    },
    setPartner(state, value) {
      localStorage.setItem("partner", JSON.stringify(value));
      state.partner = value;
    },
    setSeller(state, value) {
      localStorage.setItem("seller", JSON.stringify(value));
      state.seller = value;
    },
    setGroupAdmin(state, value) {
      localStorage.setItem("groupAdmin", JSON.stringify(value));
      state.groupAdmin = value;
    },
    setPodcaster(state, value) {
      localStorage.setItem("podcaster", JSON.stringify(value));
      state.podcaster = value;
    },
    setPodcastAdmin(state, value) {
      localStorage.setItem("podcastAdmin", JSON.stringify(value));
      state.podcastAdmin = value;
    },
    setPodcasterLoggedIn(state, value) {
      state.isPodcasterLoggedIn = value;
    },
    setPodcastAdminLoggedIn(state, value) {
      state.isPodcastAdminLoggedIn = value;
    },
    // ___ Network Admin ___
    setNetworkAdminLoggedIn(state, value) {
      state.isNetworkAdminLoggedIn = value;
    },
    setNetworkAdmin(state, value) {
      localStorage.setItem("networkAdmin", JSON.stringify(value));
      state.networkAdmin = value || {};
    },
    // ___ Auxigen ___
    setAuxigenLoggedIn(state, value) {
      state.isAuxigenLoggedIn = value;
    },
    setAuxigen(state, value) {
      localStorage.setItem("auxigen", JSON.stringify(value));
      state.auxigen = value || {};
    },

    setLoading(state, isLoading) {
      if (isLoading == true) {
        state.loadingRequest++;
        state.isLoading = isLoading;
      } else {
        state.loadingRequest--;
        if (state.loadingRequest <= 0) {
          state.isLoading = false;
        }
      }
    },
    setAdminLoggedIn(state, value) {
      state.isAdminLoggedIn = value;
    },
    setAdmin(state, value) {
      localStorage.setItem("admin", JSON.stringify(value));
      state.admin = value;
    },
    setShows(state, value) {
      state.shows = value;
    },
    setPodcasters(state, value) {
      state.podcasters = value;
    },
    setPodcastersWithReferrals(state, value) {
      state.podcastersWithReferrals = value;
    },
    setEpisodes(state, value) {
      state.episodes = value;
    },
    setReferrals(state, value) {
      state.referrals = value;
    },
    setCampaigns(state, value) {
      state.campaigns = value;
    },
    setAlerts(state, value) {
      state.alerts = value;
    },
    setSellers(state, value) {
      state.sellers = value;
    },
    setGroups(state, value) {
      state.groups = value;
    },
  },
  getters: {
    currentTheme() {
      return localStorage.getItem("theme") || "light";
    },
    partner(state) {
      return state.partner;
    },
    seller(state) {
      return state.seller;
    },
    groupAdmin(state) {
      return state.groupAdmin;
    },
    podcaster(state) {
      return state.podcaster;
    },
    podcastAdmin(state) {
      return state.podcastAdmin;
    },
    // ___ Network Admin ___
    networkAdmin: (state) => {
      return state.networkAdmin;
    },
    isNetworkAdminLoggedIn(state) {
      return state.isNetworkAdminLoggedIn;
    },
    // ___ Auxigen ___
    auxigen: (state) => {
      return state.auxigen;
    },
    isAuxigenLoggedIn(state) {
      return state.isAuxigenLoggedIn;
    },

    isLoading(state) {
      return state.isLoading;
    },
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
    isSellerLoggedIn(state) {
      return state.isSellerLoggedIn;
    },
    isGroupAdminLoggedIn(state) {
      return state.isGroupAdminLoggedIn;
    },
    isPodcasterLoggedIn(state) {
      return state.isPodcasterLoggedIn;
    },
    isPodcastAdminLoggedIn(state) {
      return state.isPodcastAdminLoggedIn;
    },
    sellerId(state) {
      return state.sellerId;
    },
    sellerPartnerId(state) {
      return state.sellerPartnerId;
    },
    podcasterId(state) {
      return state.podcasterId;
    },
    isAdminLoggedIn(state) {
      return state.isAdminLoggedIn;
    },

    podcasters(state) {
      return state.podcasters;
    },
    podcastersWithReferrals(state) {
      return state.podcastersWithReferrals;
    },
    shows(state) {
      return state.shows;
    },
    referrals(state) {
      return state.referrals;
    },
    episodes(state) {
      return state.episodes;
    },
    campaigns(state) {
      return state.campaigns;
    },
    alerts(state) {
      return state.alerts;
    },
    sellers(state) {
      return state.sellers;
    },
    groups(state) {
      return state.groups;
    },
  },
  actions: {
    async loadShows({ state, commit }, { token, fields = null } = {}) {
      try {
        commit("setLoading", true);

        const url = state.isNetworkAdminLoggedIn
          ? `${API_BASE_URL}/admin-network/shows`
          : `${API_BASE_URL}/podcaster/shows/all`;

        // Build query params
        const params = {};
        if (fields) {
          params.fields = fields.join(",");
        }

        const { data } = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        });

        if (data) {
          const labelCounts = {};
          const normalizeBoolean = (value) => {
            if (value === null || value === undefined) {
              return null;
            }
            if (typeof value === "boolean") {
              return value;
            }
            if (typeof value === "number") {
              return value === 1;
            }
            if (typeof value === "string") {
              const normalized = value.trim().toLowerCase();
              if (
                normalized === "true" ||
                normalized === "t" ||
                normalized === "1"
              ) {
                return true;
              }
              if (
                normalized === "false" ||
                normalized === "f" ||
                normalized === "0"
              ) {
                return false;
              }
            }
            return Boolean(value);
          };
          const formatDateTime = (value) =>
            value ? moment(value).utc().format("YYYY-MM-DD HH:mm:ss") : "";

          const processedShows = data.podcastShows
            .map((item) => {
              if (item.show_title) {
                if (!labelCounts[item.show_title]) {
                  labelCounts[item.show_title] = 0;
                }
                labelCounts[item.show_title] += 1;

                item.show_title =
                  labelCounts[item.show_title] > 1
                    ? `${item.show_title}_${labelCounts[item.show_title] - 1}`
                    : item.show_title;
              }

              return {
                ...item,
                last_fetched: formatDateTime(item.last_fetched),
                is_ai: normalizeBoolean(item.is_ai),
                is_active: normalizeBoolean(item.is_active),
              };
            })
            .sort((a, b) => {
              const titleA = a.show_title?.toLowerCase() || "";
              const titleB = b.show_title?.toLowerCase() || "";
              return titleA > titleB ? 1 : -1;
            });

          commit("setShows", processedShows);
        }
      } catch (err) {
        console.log(err.message);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadPodcasters({ state, commit }, { token, fields = null } = {}) {
      try {
        commit("setLoading", true);
        const url = state.isNetworkAdminLoggedIn
          ? `${API_BASE_URL}/admin-network/podcasters`
          : `${API_BASE_URL}/admin/podcasters`;

        // Build query params
        const params = {};
        if (fields) {
          params.fields = fields.join(",");
        }

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        });
        if (response.data) {
          commit(
            "setPodcasters",
            response.data
              .map((item) => ({
                ...item,
                campaigns_end_date: item.campaigns_end_date
                  ? moment(item.campaigns_end_date).utc().format("YYYY-MM-DD")
                  : null,
                created_at: moment(item.created_at).utc().format("YYYY-MM-DD"),
              }))
              .sort((a, b) => {
                if (
                  a.created_at == "Invalid date" &&
                  b.created_at != "Invalid date"
                )
                  return -1;
                if (
                  a.created_at != "Invalid date" &&
                  b.created_at == "Invalid date"
                )
                  return 1;
                return a.created_at > b.created_at ? 1 : -1;
              })
          );
        }
      } catch (error) {
        console.error("Error fetching podcasters:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadPodcastersWithReferrals(
      { commit },
      { token, fields = null } = {}
    ) {
      try {
        commit("setLoading", true);
        const params = {
          withReferralsOnly: "true",
        };
        if (fields) {
          params.fields = fields.join(",");
        }

        const response = await axios.get(API_BASE_URL + "/admin/podcasters", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        });
        if (response.data) {
          commit(
            "setPodcastersWithReferrals",
            response.data.map((item) => ({
              ...item,
              created_at: moment(item.created_at)
                .utc()
                .format("YYYY-MM-DD HH:mm:ss"),
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching podcasters with referrals:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadEpisodes({ commit }, { token, params = {} } = {}) {
      try {
        const response = await axios.get(API_BASE_URL + "/podcaster/episodes", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        });

        const episodes = response.data?.episodes || [];
        const total =
          response.data?.total !== undefined
            ? response.data.total
            : episodes.length;

        commit("setEpisodes", episodes);
        return { episodes, total };
      } catch (error) {
        console.error("Error fetching episodes:", error);
        return { episodes: [], total: 0 };
      }
    },
    async loadReferrals({ commit }, { token }) {
      try {
        commit("setLoading", true);
        const response = await axios.get(
          API_BASE_URL + "/podcaster/referrals",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data?.referrals) {
          commit("setReferrals", response.data.referrals);
        }
      } catch (error) {
        console.error("Error fetching referrals:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadCampaigns({ commit }, { token }) {
      try {
        commit("setLoading", true);
        const response = await axios.get(API_BASE_URL + "/campaigns", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data) {
          commit(
            "setCampaigns",
            response.data.map((item) => ({
              ...item,
              ctr: item.ctr.toFixed(2),
              start_date: moment(item.start_date).utc().format("YYYY-MM-DD"),
              end_date: moment(item.end_date).utc().format("YYYY-MM-DD"),
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadAlerts({ commit }, { token }) {
      try {
        commit("setLoading", true);
        const response = await axios.get(API_BASE_URL + "/alerts", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data) {
          commit(
            "setAlerts",
            response.data
              .map((item) => ({
                ...item,
                timestamp: moment(item.timestamp)
                  .utc()
                  .format("YYYY-MM-DD HH:mm:ss"),
              }))
              .sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1))
          );
        }
      } catch (error) {
        console.error("Error fetching alerts:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadSellers({ commit }, { token }) {
      try {
        commit("setLoading", true);
        const response = await axios.get(API_BASE_URL + "/member-list/seller", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data) {
          commit(
            "setSellers",
            response.data.sellers.map((item) => {
              return {
                ...item,
                value: `${item.partner_id}_${item.id}`,
              };
            })
          );
        }
      } catch (error) {
        console.error("Error fetching sellers:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async loadGroups({ commit }, { token }) {
      try {
        commit("setLoading", true);
        const response = await axios.get(API_BASE_URL + "/member-list/group", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data) {
          commit(
            "setGroups",
            response.data.groups.map((item) => {
              return {
                ...item,
                label: `${item.id}_${item.name}`,
              };
            })
          );
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
      } finally {
        commit("setLoading", false);
      }
    },
  },
  modules: {
    AdminNewDashboardStore,
  },
});
